import React, { useEffect, useState } from "react";
import "../../Styles/Settings/ThankYouSetting.css";
import Actionbutton from "../../Assets/Actionbutton.png";
import ThanksModal from "./SettingModals/ThanksModal";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createNewForm } from "../../Redux/Reducer/FormSlices";

const ThankYouSetting = () => {
  const [showTanksPage, setShowThanksPage] = useState(true);
  const [showExternalLink, setShowExternalLink] = useState(false);

  const [image, setImage] = useState("");
  const [showimageUpLoaded, setImageUploaded] = useState(true);
  const handelChangeThanksPage = () => {
    setShowThanksPage(!showTanksPage);
    setShowExternalLink(false);
  };

  const handelChangeThanksLink = () => {
    setShowThanksPage(false);
    setShowExternalLink(!showExternalLink);
  };
  const [externalLink, setExternalLink] = useState("");

  const [thanksPageImage, setThanksPageImage] = useState("");
  const [thanksPageDescription, setThanksPageDescription] = useState(
    "Your submission has been received."
  );

  const [openActionAddButton, setOpenActionButtion] = useState(false);
  const [selectedImageIdx, setSelectedImageIdx] = useState(null);
  const handelActionButton = () => {
    setOpenActionButtion(!openActionAddButton);
  };

  const formId = useParams().formId;
  const getDefaultImage = async (type) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/forms/retrieve`,
        { fileKey: type }
      );
      return response.data.url; // Return the URL
    } catch (error) {
      console.error("Error fetching default image:", error);
      return null; // Return fallback value for failed requests
    }
  };

  //get form settings
  const fetchFormSettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/forms/singleFormSettings/${formId}`
      );
      if (response.data.status) {
        console.log(response.data.thanksSettings.customThanksPage.image);
        // setIsValidFormMake(false);
        setThanksPageImage(
          await getDefaultImage(
            response.data.thanksSettings.customThanksPage.image
          )
        );
        setThanksPageDescription(
          response.data.thanksSettings.customThanksPage.thanksDescription
        );
        console.log(response.data.thanksSettings.customThanksPage.image);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchFormSettings();
  }, [formId]);

  const handelSaveUrl = async () => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        {
          type: "thanksSettings",
          value: {
            redirectUrl: "",
            customThanksPage: {
              image: "",
              thanksDescription: "",
            },
          },
        }
      );
      console.log(response.data.thanksSettings);
    } catch (error) {
      console.log(error);
    }
  };

  const uploadFileToS3 = async (file) => {
    try {
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(
          `${process.env.REACT_APP_API}/forms/thanksimage`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        return response.data.fileUrls.fileKey; // Return the file URL from S3
      } else {
        return "";
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      throw new Error("Failed to upload file");
    }
  };

  const handelCreateCustomThanksPage = async () => {
    if (!showimageUpLoaded) {
      try {
        console.log("hello 1");
        const getImage = await uploadFileToS3(image);
        const value = {
          type: "thanksSettings",
          value: {
            image: getImage,
            thanksDescription: thanksPageDescription,
          },
        };

        const response = await axios.put(
          `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
          value
        );
        if (response.status === 200) {
          fetchFormSettings();
          setOpenActionButtion(!openActionAddButton);
          setSelectedImageIdx(null);
          setShowSelctedImage("");
          setThanksPageImage("");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        console.log("hello 2");

        const value = {
          type: "thanksSettings",
          value: {
            image: thanksPageImage,
            thanksDescription: thanksPageDescription,
          },
        };
        const response = await axios.put(
          `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
          value
        );
        console.log(response.data);
        if (response.status === 200) {
          fetchFormSettings();
          setOpenActionButtion(!openActionAddButton);
          setSelectedImageIdx(null);
          setShowSelctedImage("");
          setThanksPageImage("");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const [showSelctedImage, setShowSelctedImage] = useState("");
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setShowSelctedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
    setImage(file);
  };

  const handelSelected = (selectedImage, idx) => {
    setThanksPageImage(selectedImage.text);
    setSelectedImageIdx(idx);
  };

  const dispatch = useDispatch();
  const nevigate = useNavigate();

  const handelSavethanksSetting = async () => {
    try {
      const value = {
        type: "thanksSettings",
        value: {
          redirectUrl: externalLink,
          customThanksPage: {
            image: "",
            thanksDescription: "",
          },
        },
      };
      const response = await axios.put(
        `${process.env.REACT_APP_API}/forms/singleFormSetting/${formId}`,
        value
      );
      if (response.status === 200) {
        dispatch(createNewForm(response.data.formDetails));
        nevigate(`/create-form/${formId}/question`);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      className="thanks-setting-container-main"
    >
      <div className="response-setting-container">
        <ThanksModal
          isOpen={openActionAddButton}
          showSelctedImage={showSelctedImage}
          setShowSelctedImage={setShowSelctedImage}
          onClose={handelActionButton}
          thanksPageImage={thanksPageImage}
          setThanksPageImage={setThanksPageImage}
          thanksPageDescription={thanksPageDescription}
          setThanksPageDescription={setThanksPageDescription}
          setOpenActionButtion={setOpenActionButtion}
          openActionAddButton={openActionAddButton}
          showimageUpLoaded={showimageUpLoaded}
          setImageUploaded={setImageUploaded}
          selectedImageIdx={selectedImageIdx}
          setSelectedImageIdx={setSelectedImageIdx}
          image={image}
          setImage={setImage}
          handelSelected={handelSelected}
          onAdd={handelCreateCustomThanksPage}
          handleFileChange={handleFileChange}
        />
        <div className="type-of-showThanksPage">
          <div
            className="single-typepage-thankspage"
            onClick={() => handelChangeThanksPage}
          >
            <input
              type="radio"
              checked={showTanksPage}
              onChange={() => handelChangeThanksPage()}
            />
            <div>Show a thank you page after submission</div>
          </div>

          {showTanksPage && (
            <div className="showing-desing-container">
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "8px",
                }}
              >
                <button onClick={() => handelActionButton()}>
                  <img src={Actionbutton} alt="Actionbutton" />
                  Action button
                </button>
              </div>
              <hr style={{ height: "0.2rem", borderColor: "#d3dce5" }} />
              <div className="thankspage-model">
                <div className="thanks-content-container">
                  <div style={{ width: "50%", height: "50%" }}>
                    <img
                      src={thanksPageImage}
                      alt="thanksPageDescription"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <h1>Thank you</h1>
                  <div className="thanksPage_des">{thanksPageDescription}</div>
                </div>
              </div>
            </div>
          )}
          <div
            className="single-typepage-thankspage"
            onClick={() => handelChangeThanksLink()}
          >
            <input
              type="radio"
              checked={showExternalLink}
              onChange={() => handelChangeThanksLink()}
            />
            <div>Redirect to an external link after submission</div>
          </div>
          {showExternalLink && (
            <div className="external-link-container">
              <div className="external-link-head">Enter URL</div>
              <input
                className="external-link-inputcontainer"
                value={externalLink}
                onChange={(e) => setExternalLink(e.target.value)}
                placeholder="Enter URL"
              />
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          borderTop: "1px solid #D3DCE5",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          style={{
            padding: "0.81rem 1.5rem",
            backgroundColor: "#1B51BB",
            borderRadius: "6px",
            color: "#ffffff",
          }}
          onClick={handelSavethanksSetting}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ThankYouSetting;
